import { Fragment, useEffect } from "react";
import ReactDOM from "react-dom";
import classes from "./Modal.module.css";

const Backdrop = (props) => {
  return <div className={classes.backdrop} />;
};

const ModalOverlay = (props) => {
  const modalStyle = props.style || {};
  const hasCustomWidth =
    modalStyle.minWidth || modalStyle.maxWidth || modalStyle.width;

  // If custom width is provided, add a class for centering
  // Also apply transform via inline style to ensure it works with animation
  const combinedStyle = hasCustomWidth
    ? {
        ...modalStyle,
        // Apply transform inline to ensure it works with animation
        transform: "translateX(-50%) translateY(0)",
        left: "50%",
      }
    : modalStyle;

  const className = `modern-modal ${
    hasCustomWidth ? classes.modalCustomWidth : ""
  } ${props.className || ""}`.trim();

  return (
    <div
      className={className}
      style={Object.keys(combinedStyle).length > 0 ? combinedStyle : undefined}
    >
      <div className={classes.content} style={{ position: "relative" }}>
        {props.children}
      </div>
    </div>
  );
};

const portalElement = document.getElementById("overlays");

const ModalModern = (props) => {
  // Lock body scroll when modal is open
  useEffect(() => {
    const scrollBarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // 1. Save state
    const originalStyles = {
      overflow: document.body.style.overflow,
      paddingRight: document.body.style.paddingRight,
      position: document.body.style.position,
      top: document.body.style.top,
      width: document.body.style.width,
    };

    // 2. The Nuclear Lock: position fixed + overflow hidden
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollTop}px`; // Keeps your scroll position
    document.body.style.width = "100%";
    document.body.style.paddingRight = `${scrollBarWidth}px`;

    return () => {
      // 3. Restore everything
      document.body.style.overflow = originalStyles.overflow;
      document.body.style.position = originalStyles.position;
      document.body.style.top = originalStyles.top;
      document.body.style.width = originalStyles.width;
      document.body.style.paddingRight = originalStyles.paddingRight;

      // 4. Snap back to where the user was
      window.scrollTo(0, scrollTop);
    };
  }, []);

  return (
    <Fragment>
      {ReactDOM.createPortal(<Backdrop />, portalElement)}
      {ReactDOM.createPortal(
        <ModalOverlay style={props.style}>{props.children}</ModalOverlay>,
        portalElement,
      )}
    </Fragment>
  );
};

export default ModalModern;
